// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"54bc06af","636":"2821ac07"}[chunkId] + ".chunk.css";
};